module.exports = __webpack_public_path__ + "img/mental.80191a08.jpg";